import ReactDOM from 'react-dom';
import wrapWithStore from './wrapWithStore';

import './intl';

// the chunks for this will get created for monolith, but intl
// will already be loaded thanks to them being added to
// the webpack entry config so webpack won't try to
// load them again
import { initialize } from './intl/polyfill';

import sentry from 'raven-js';

const { SENTRY_DSN, RELEASE } = window && window.ZD ? window.ZD.configs : {};

if (SENTRY_DSN) {
    // client-side error reporting
    // https://docs.sentry.io/clients/javascript/config/
    sentry.config(SENTRY_DSN, {
        release: RELEASE,
        // The secret key is deprecated/remove in sentry 9. CI is still on sentry 8 though and needs it
        // set allowSecretKey: true so the sdk doesn't error out in CI
        allowSecretKey: true,
        // This will prevent errors from these domains from getting reported to sentry
        ignoreUrls: [/cdn\.speedcurve\.com/, /cdn\.branch\.io/, /fbcdn\.net/, /spdcrv\.global\.ssl\.fastly\.net/],
    }).install();
}

export default async function renderPage({
    component,
    el,
    initialState,
    postGaCustomMiddleware,
    preGaCustomMiddleware,
    reducers,
    routes,
    theme,
    pageName,
}) {
    await initialize();

    let messages;
    const locale = window.ZD.configs.LOCALE || 'en';

    if (locale === 'es') {
        messages = await import('./intl/message-es.json');
    }


    ReactDOM.hydrate(
        wrapWithStore({
            component,
            initialState,
            postGaCustomMiddleware,
            preGaCustomMiddleware,
            reducers,
            routes,
            theme,
            pageName,
            messages,
            locale,
        }), el || document.getElementById('main'), () => {
            if (window.performance && window.performance.mark) {
                window.performance.mark('react-is-ready');
            }
        }
    );
}
